<template>
    <div class="home-container">
        <div style="padding: 25px 55px 0;">
            <div class="level" style="justify-content:space-between;">
                <div class="level">
                    <div class="blue-flag"></div>
                    <div class="home-title blue-bottom">工作动态</div>
                </div>
                <div class="home-tomore" @click="togz">查看更多 ></div>
            </div>
            <el-divider></el-divider>
            <div class="level">
                <div class="imglist-container">
                    <el-carousel ref="imgList" height="300px" indicator-position="none" arrow="never" @change="changeImg">
                        <el-carousel-item v-for="(item,index) in newsList1" :key="index">
                            <img style="height:300px;width:400px;cursor:pointer" :src="item.attachments" alt="" @click="togzDetail(index)">
                        </el-carousel-item>
                        <div class="indicator-container level">
                            <div class="img-title">{{title | ellipsis}}</div>
                            <div class="level">
                                <div :class="imgIndex==index?'active-circle':'inactive-circle'" v-for="(item,index) in newsList1" :key="index" @click.stop="toImg(index)"></div>
                            </div>
                        </div>
                    </el-carousel>
                </div>
                <div class="news-container">
                    <div class="news1-title">{{newsInfo.title}}</div>
                    <!-- newsInfo.summary -->
                    <div class="news1-content" @click="togzDetail(3)">{{newsInfo.summary | ellipsis2}}
                        <div style="text-align:right;font-size:16px;">{{newsInfo.createDate|datetime}}</div>
                    </div>
                    <div class="news-list level" v-for="(item,index) in newsList2" :key="index"  @click="togzDetail(index+4)">
                        <div>{{item.title | ellipsis3}}</div>
                        <div class="time-color">{{item.createDate|datetime}}</div>
                    </div>
                </div>
            </div>
            <div class="level" style="margin-top:45px;justify-content:space-between;margin-bottom:65px;">
                <div style="width:48%">
                    <div class="level" style="justify-content:space-between;">
                        <div class="level">
                            <div class="blue-flag"></div>
                            <div class="home-title">上海市嘉定区公共租赁住房运营有限公司</div>
                        </div>
                        <div class="home-tomore" @click="toUrl('http://prh.jdgzf.net/#/ContactUs?name=%E5%85%AC%E5%8F%B8%E7%AE%80%E4%BB%8B&type=0&id=54')">查看更多 ></div>
                    </div>
                    <div class="part2-container" style="margin-top:29px">
                        <div style="padding:36px 20px 28px;">
                            <div class="company-introduction">{{'上海市嘉定区公共租赁住房运营有限公司是下属于上海嘉定住房建设发展（集团）有限公司的全资子公司。成立于2011年6月30日，注册资本6亿元。公租房公司经营范围为公租房项目开发建设、租配和物业管理、资产经营与管理等。其主要职能为：1、收储和配建房源；2、对公租房统一进行装修、家具配置；3、规范和完善租配管理、物业管理机制；4、指导街镇公共租赁住房的运营管理等；5、加强监管职能，努力实现优势互补，形成合力，创新体制机制。'|ellipsis4}}</div>
                            <div class="level company-units">
                                <div class="company-unit" @click="toUrl('http://rent.jdgzf.net/')">
                                    <img src="../../assets/jdprotal/dwsq.png" alt="">
                                    <div style="margin-top:10px">单位申请</div>
                                </div>
                                <div class="company-unit" @click="toUrl('http://prh.jdgzf.net')">
                                    <img src="../../assets/jdprotal/grsq.png" alt="">
                                    <div style="margin-top:10px">个人申请</div>
                                </div>
                                <div class="company-unit" @click="toUrl('http://rent.jdgzf.net/')">
                                    <img src="../../assets/jdprotal/jdcx.png" alt="">
                                    <div style="margin-top:10px">进度查询</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width:48%">
                    <div class="level" style="justify-content:space-between;">
                        <div class="level">
                            <div class="blue-flag"></div>
                            <div class="home-title blue-bottom">下属企业</div>
                        </div>
                        <div class="home-tomore" @click="togy">查看更多 ></div>
                    </div>
                    <div class="part2-container" style="margin-top:29px">
                        <div style="padding:16px 30px 16px 20px;">
                            <el-carousel height="210px" indicator-position="none" :interval="5000">
                                <el-carousel-item v-for="(item,index) in qyList" :key="index" style="display:flex;cursor:pointer">
                                    <img style="height:210px;width:240px;flex-shrink: 0;" :src="item.attachments" alt="" @click="togyDetail(item.id)">
                                    <div style="margin:10px 0 0 0;" @click="togyDetail(item.id)">
                                        <div class="company-title">{{item.title}}</div>
                                        <div class="company-introduction2">{{item.summary}}</div>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FloatLink :imgUrl="imgUrl" :linkUrl="linkUrl"></FloatLink>
    </div>
</template>

<script>
import {  get, post } from "@/api/common/index";
import FloatLink from "@/components/common/FloatLink.vue";
export default {
    data(){
        return{
            title:'',
            imgIndex:0,
            newsList1:[],
            newsInfo:{},
            newsList2:[],
            newsList:[],
            gzid:null,
            qyid:null,
            jtdtid:null,
            qyList:[],
            imgUrl:[],
            linkUrl:[],
        }
    },
    components: { FloatLink },
    methods:{
        togz(){
            this.$router.push({path:'/InfoList',query:{id:this.jtdtid,index:1}})
        },
        togzDetail(index){
            this.$router.push({path:'/InfoList',query:{id:this.jtdtid,index:1,newsIndex:this.newsList[index].id,tipIndex:0}})
        },
        togy(){
            this.$router.push({path:'/InfoList',query:{id:this.qyid,index:6}})
        },
        togyDetail(index){
            this.$router.push({path:'/InfoList',query:{id:this.qyid,index:6,newsIndex:index,tipIndex:0}})
        },
        toImg(index){
            this.$refs.imgList.setActiveItem(index)
        },
        changeImg(cur,pre){
            this.imgIndex = cur
            this.title = this.newsList1[this.imgIndex].title
        },
        toUrl(url){
            let a = document.createElement('a')
            a.setAttribute('target','view_window')
            a.href = url
            a.click()
        },
        getMenuList(){
            get('/api/website/get_menu_list').then(res => {
                if (res.success) {
                    var list = res.data
                    if(list.length>1){
                        for(var i = 0;i<list[1].menuEntities.length;i++){
                            this.jtdtid = list[1].id
                            if(list[1].menuEntities[i].name=='工作动态'){
                                this.gzid = list[1].menuEntities[i].id
                                this.getNewsList()
                            }
                        }
                    }
                    for(var i = 0;i<list.length;i++){
                        if(list[i].name=='下属企业'){
                            this.qyid = list[i].id
                            this.getQYList()
                        }
                    }
                }
            }, error => {
                this.$message({
                    message: error,
                    type: "error",
                });
            })
        },
        getQYList(){
            get('/api/website/get_news_list',{codeID:this.qyid,pageSize:9999,pageIndex:0}).then(res => {
                if (res.success) {
                    this.qyList = res.data
                }
            }, error => {
                this.$message({
                    message: error,
                    type: "error",
                });
            })
        },
        getNewsList(){
            get('/api/website/get_news_list',{codeID:this.gzid,pageSize:8,pageIndex:0}).then(res => {
                if (res.success) {
                    this.newsList = res.data
                    this.newsList1 = this.newsList.slice(0,3)
                    if(this.newsList1.length>0){
                        this.title = this.newsList1[0].title
                    }
                    if(this.newsList.length>3){
                        this.newsInfo = this.newsList[3]
                    }
                    if(this.newsList.length>4){
                        this.newsList2 = this.newsList.slice(4,8)
                    }
                }
            }, error => {
                this.$message({
                    message: error,
                    type: "error",
                });
            })
        },
        getAdvertisement(type){
            get('/api/website/get_advertisement_list').then(res => {
                if (res.success) {
                    var list = []
                    for(var i = 0;i<res.data.length;i++){
                        if(res.data[i].type==1){
                            list.push(res.data[i])
                        }
                    }
                    this.imgUrl = list
                    this.linkUrl = list
                } 
            }, error => {
                this.$message({
                    message: error,
                    type: "error",
                });
            })
        },
    },
    created(){
        this.getMenuList()
        this.getAdvertisement()
        
    },
    activated(){
        
    },
    deactivated(){

    },
    filters: {
        ellipsis (value) {
            if(value){
                if (value.length > 18) {
                    return value.slice(0,18) + '...'
                }
            }
            return value
        },
        ellipsis2 (value) {
            if(value){
                if (value.length > 110) {
                    return value.slice(0,110) + '...'
                }
            }
            return value
        },
        ellipsis3 (value) {
            if(value){
                if (value.length > 36) {
                    return value.slice(0,36) + '...'
                }
            }
            return value
        },
        ellipsis4 (value) {
            if(value){
                if (value.length > 74) {
                    return value.slice(0,74) + '...'
                }
            }
            return value
        },
    },
}
</script>

<style scoped>
.level{
    display: flex;
    align-items: center;
}
.home-container{
    width: 1298px;
    margin: 0 auto;
}
.blue-flag{
    height: 25px;
    background: #1965b5;
    border-radius: 2px;
    width: 4px;
}
.home-title{
    font-size: 20px;
    color: #333333;
    padding: 5px 16px 5px 10px;
}
.blue-bottom{
    border-bottom: 2px solid #1965b5;
}
.home-tomore{
    font-size: 14px;
    color: #999999;
    cursor: pointer;
}
.imglist-container{
    width: 400px;
    position: relative;
}
.indicator-container{
    background: rgba(51 ,51 ,51 ,0.6);
    padding: 16px 20px;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    z-index: 999;
    width: calc(100% - 40px);
    left: 0;
}
.img-title{
    font-size: 14px;
    color: #FFFFFF;
}
.active-circle{
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: #FFB559;
    margin-left: 10px;
}
.inactive-circle{
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: #E6E6E6;
    cursor: pointer;
    margin-left: 10px;
}
.news-container{
    padding: 13px 26px 0 50px;
    height: 287px;
    width: calc(100% - 476px);
}
.news1-title{
    font-size: 18px;
    line-height: 18px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 4px;
}
.news1-content:hover{
    color: red;
}
.news1-content{
    font-size: 12px;
    line-height: 28px;
    color: #666666;
    height: 84px;
    cursor: pointer;
}
.news-list{
    font-size: 16px;
    color: #333333;
    justify-content: space-between;
    margin-top: 24px;
    cursor: pointer;
}
.news-list:hover{
    color: red;
}
/* .time-color:not(:hover){
    color:#666666
} */
.part2-container{
    width: 575px;
    height: 245px;
    border: 1px solid #E6E6E6;
}
.company-introduction{
    font-size: 14px;
    color: #444444;
    line-height: 30px;
    text-indent:28px;
}
.company-units{
    justify-content: space-between;
    margin-top: 12px;
}
.company-unit{
    font-size: 14px;
    color: #333333;
    text-align: center;
    padding: 20px 50px ;
    background: #F2F7FA;
    cursor: pointer;
}
.company-unit img{
    width: 40px;
    height: 40px;
    display: block;
    margin: 0 auto;
}
.company-title{
    font-size: 14px;
    color: #333333;
    text-align: center;
}
.company-introduction2{
    font-size: 14px;
    color: #666666;
    line-height: 28px;
    text-align: left;
    text-indent: 28px;
    margin: 20px 20px 0;
}
</style>